module.exports = __webpack_public_path__ + "media/images/pic/testimonials/klaudia-58b8fda33e5a648bc41aaa3cb84c2112.jpg";